import { useHistory } from "react-router-dom";

const OUTCOMES = {
  completed: {
    alertClass: "alert-success",
    title: "Payment Successful",
    message: "Thanks, your payment has been received.",
  },
  failed: {
    alertClass: "alert-danger",
    title: "Payment Failed",
    message: "Your payment could not be completed.",
  },
};

const UNKNOWN_OUTCOME = {
  alertClass: "alert-warning",
  title: "Payment Status Unknown",
  message: "We could not confirm the outcome of this payment.",
};

function App() {
  const history = useHistory();

  const params = new URLSearchParams(window.location.search);
  const paymentIntentId = params.get("payment_intent_id");
  const status = params.get("status");

  const outcome = OUTCOMES[status] || UNKNOWN_OUTCOME;

  return (
    <div className="page demo">
      <div className="onboarding">
        <div className="onb-aside w-100">
          <div className="t-section">
            <a href="javascript:void(0)">
              <img alt="Logo" src="logo.png" className="h-40px"/>
            </a>
            <div className="mw-325px">
              <h3>Hosted Payment Page Portal</h3>
              <p className="mb-0">
                You have been returned from the hosted payment page
              </p>
            </div>
          </div>
        </div>
        <div className="onb-body">
          <div className={"form"}>
            <div className={"s-card"}>
              <div className={`alert ${outcome.alertClass} mb-0 text-start`}>
                <h6>{outcome.title}</h6>
                <div>{outcome.message}</div>
              </div>

              <div className="form-group mt-6">
                <label className="form-label fw-normal">Payment ID</label>
                <input
                  className="form-control"
                  value={paymentIntentId || "-"}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label className="form-label fw-normal">Status</label>
                <input
                  className="form-control"
                  value={status || "-"}
                  readOnly
                />
              </div>
            </div>

            <button
              className="btn btn-primary w-100"
              type="button"
              onClick={() => history.push("/hosted-payment-page")}
            >
              Start Another Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
